import type { FunctionComponent } from "react";
import { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { SERVER_ROOT } from "../scripts/constants";

type Params = {
  uid: string;
};

const NexToMeet: FunctionComponent = () => {
  const { uid } = useParams<Params>();

  const searchParams: URLSearchParams = new URLSearchParams(
    window.location.search
  );

  const version = searchParams.get("version") as any;
  const isV2Cmp = Boolean(
    typeof version !== "undefined" && parseInt(version) >= 2
  );

  const [error, setError] = useState<any | null>(null);
  const [hostUrl, setHostUrl] = useState<string | undefined>(undefined);

  useEffect(() => {
    if (uid) {
      (async () => {
        await axios
          .get(`${SERVER_ROOT}/nextomeet/host`, {
            params: { uid },
          })
          .then(({ data }) => {
            const { nextomeetHostUrl } = data;
            setHostUrl(nextomeetHostUrl);
          })
          .catch((e: any) => {
            setError(e);
          });
      })();
    }
  }, [uid, setError, setHostUrl]);

  return (
    <div
      id="nextomeet-embed-parent"
      style={
        isV2Cmp
          ? {
              alignItems: "center",
              aspectRatio: `${16 / 9}`,
              display: "flex",
              justifyContent: "center",
              position: "absolute",
              height: "100vh",
            }
          : {
              alignItems: "center",
              aspectRatio: `${16 / 9}`,
              display: "flex",
              justifyContent: "center",
              left: "-50px",
              position: "absolute",
              width: 1754, // try width: "92vw" if not good
            }
      }
    >
      {hostUrl && (
        <iframe
          allow="camera;microphone"
          id="nextomeet-embed-iframe"
          src={hostUrl}
          style={{
            border: "0px",
            height: "100%",
            width: "100%",
          }}
        />
      )}
      {!hostUrl && (
        <>{error ? error?.message : "Waiting to join NexToMeet room ..."}</>
      )}
    </div>
  );
};

export default NexToMeet;
